<template>
	<div
		v-if="active"
		:class="{
			'page--active' : active
		}"
		class="page"
	>
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		initialActive: {
			type: Boolean,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			active: false,
		};
	},
	watch: {
		initialActive() {
			this.active = this.initialActive;
		},
	},
	created() {
		this.active = this.initialActive;
	},
};
</script>

<style lang="scss" scoped src="./page.scss" />
